var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"down-detail-wrapper"},[_c('Table',{attrs:{"curPage":_vm.curPage,"config":_vm.tableConfig,"dataset":_vm.tableData,"total":_vm.standTotal},on:{"columnClick":_vm.tableColumnClick,"pageChange":_vm.pageChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }